<template>
  <div class="my-4 align-self-center">
      <b-form @submit="submitLogin" id="form-login">
        <InputLogin v-model="login" :validation-message="validation.login" label="Login" @change="validateLogin"/>
        <InputPassword v-model="password" :validation-message="validation.password" :noBorder="true"/>
        <div class="d-flex justify-content-between w-100">
          <LinksFormLogin />
          <b-button pill class="btn-base primary-btn entrar" type="submit">Entrar</b-button>      
        </div>
      </b-form>
      <br/>
      <b-badge class="mb-3 mt-4" :variant="validation.variant" v-if="validation.msg" style="white-space: break-spaces;">
          {{ validation.msg }}
      </b-badge>
  </div>
</template>

<script>
import LinksFormLogin from "./LinksFormLogin"
import InputLogin from "./InputLogin"
import InputPassword from "@/components/commons/Inputs/InputPassword.vue"
import Validations from "@/util/Validations"
import LoginResource from "@/resources/LoginResource"
import { mapGetters, mapActions } from "vuex"

export default {
  components: { LinksFormLogin, InputLogin, InputPassword },
  data() {
    return {
      login: null,
      password: null,
      validation: {}
    };
  },
  computed: {
    ...mapGetters("user", ["jwt"])
  },
  methods: {
    ...mapActions("user", ["saveOuthTokens"]),
    ...mapActions("app", ["redirectAfterLogin"]),
    submitLogin(event) {
      event.preventDefault();
      
      this.validation = {}

      this.validateLogin( this.login, false )
      this.validation.password = !this.password ? "Este campo é obrigatório!" : null

      if (!Validations.isEmpty(this.validation))
      {
        return
      }

      LoginResource.login(this.login, this.password, {context: "login", showLoader: true})
      .then(response => {
        
        this.validation = { variant: "success", msg: "Logado com sucesso" }

        
        this.saveOuthTokens({accessToken: response.accessToken, refreshToken: response.refreshToken, changedUser: true})
        .then(() => {
          this.$nextTick(() => {
            if (this.jwt.stepAuth == "end") {
              this.redirectAfterLogin()
            }
          })
          })
        })
        .catch(error => {
          this.validation = { variant: "danger", msg: error.message }
        })

      .catch(error => {
        this.validation = { variant: "danger", msg: error.message }
      })
    },
    validateLogin( login, forceUpdate = true ) {
      this.validation = {}

      this.validation.login = this.validateCpfEmail(login, true) || null

      if ( forceUpdate ) {
        this.$forceUpdate()
      }  
    },
    validateCpfEmail( login, required ) {

      if (!required && !login)
            return null

      if ( !login )
            return "Este campo é obrigatório!"

      if ( Validations.email(login) && Validations.cpf(login.replace(/[^\d]+/g,'') || "invalido") )
            return "Login inválido!"

      return ""
    }
  }
}
</script>

<style>
html body .primary-btn.entrar{
	font-size: 16px !important;
}
</style>